/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AcademicProgramItem model module.
 * @module model/AcademicProgramItem
 * @version 1.0
 */
class AcademicProgramItem {
    /**
     * Constructs a new <code>AcademicProgramItem</code>.
     * @alias module:model/AcademicProgramItem
     */
    constructor() { 
        
        AcademicProgramItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AcademicProgramItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AcademicProgramItem} obj Optional instance to populate.
     * @return {module:model/AcademicProgramItem} The populated <code>AcademicProgramItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AcademicProgramItem();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
AcademicProgramItem.prototype['id'] = undefined;

/**
 * @member {String} title
 */
AcademicProgramItem.prototype['title'] = undefined;






export default AcademicProgramItem;

